import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader } from "../../MenuCard";

const ITEMS = [
  { label: "Calificadora Clientes", icon: "fas fa-star",        color: "#f59e0b", bg: "#fffbeb", href: "/CalificadoraClientes", desc: "Score de clientes",    perm: "menu_reportes" },
  { label: "Abonos",                icon: "fas fa-dollar-sign", color: "#10b981", bg: "#f0fdf4", href: "/ListadoAbonos",        desc: "Historial de abonos",  perm: "menu_reportes" },
];

function BotonesReportesAdmin() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-chart-bar" color="#f59e0b" bg="#fffbeb" title="Reportes Admin" subtitle="Reportes administrativos y análisis" />
        {user.menu_reportes ? (
          <div className="row">
            {ITEMS.map((r, i) => <MenuCard key={i} {...r} enabled={!!user[r.perm]} />)}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesReportesAdmin;
